import { z } from 'zod';

export const SyncActionSchema = z.enum([
  'load',
  'refresh',
  'validate',
  'dry_run',
  'push',
  'resume',
  'resolve',
  'rollback',
]);
export type SyncAction = z.infer<typeof SyncActionSchema>;

export const SyncLogEntrySchema = z.object({
  id: z.number().int(),
  product_id: z.number().int().nullable(),
  product_name: z.string().nullable().optional(),
  user_id: z.number().int().nullable(),
  user_email: z.string().nullable().optional(),
  action: SyncActionSchema,
  unit4_env: z.enum(['test', 'prod']).nullable(),
  status: z.enum(['ok', 'failed', 'partial']),
  request_payload: z.unknown().nullable(),
  response: z.unknown().nullable(),
  operations: z.unknown().nullable(),
  error: z.string().nullable(),
  duration_ms: z.number().int().nullable(),
  created_at: z.string(),
});
export type SyncLogEntry = z.infer<typeof SyncLogEntrySchema>;

export const AuditLogEntrySchema = z.object({
  id: z.number().int(),
  user_id: z.number().int().nullable(),
  user_email: z.string().nullable().optional(),
  entity_type: z.string(),
  entity_id: z.number().int().nullable(),
  action: z.string(),
  diff: z.unknown().nullable(),
  ip: z.string().nullable(),
  created_at: z.string(),
});
export type AuditLogEntry = z.infer<typeof AuditLogEntrySchema>;
